export default __webpack_public_path__ + "static/media/events_report.6fc6b3e2.png";